import 'reactjs-popup/dist/index.css';
import Popup from 'reactjs-popup';
import { ButtonButton, Button, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { url } from '../../weburl';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';


const usersArray = ['alap', 'mockip',
    'alap', 'mockip',
    'alap', 'mockip',
    'alap', 'mockip',
    'alap', 'mockip',
    'alap', 'mockip',

]
export const ChangeDogUserModal = (props) => {
    const navigate = useNavigate()

    const [users, setUsers] = useState()

    useEffect(() => {
        axios
            .get(`${url}api/users`)
            .then((res) => {
                console.log(res)
                setUsers(res.data)
            })
            .catch((err) => console.log(err))
    }, [])

    // useEffect(()=>{

    // }, )

    const updateWithUser = (user_id, user_name) => {
        Swal.fire({
            title: `ARE YOU SURE YOU SET ${props.dog_name}?'S USER AS ${user_name}`,
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Update',
            denyButtonText: `Don't Update`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                axios
                    .post(`${url}api/dogs/update-dog-profile-user`, { dog_id: props.dog_id, user_id: user_id })
                    .then((res) => {
                        console.log(res.data)
                        
                    })
                    .catch((err) => console.log(err))

            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        })

    }

    const displayUsers = (closeEvent) => {
        if (users) {
            return users.map((item) => {
                // console.log(item)
                return (
                    <div className='col-md-4 '
                    >

                        <Paper color='primary' className='py-4 my-2 '>
                            <Button
                                onClick={(e) => updateWithUser(item['id'], item['username'])}
                            >
                                <div className='text-dark'>
                                    <p className='font-weight-bold mb-0'>{item['username']}</p>
                                    <p className='m-1 p-0 text-lowercase'>{item['email']}
                                    </p>
                                </div>
                            </Button>
                        </Paper>
                    </div>
                )
            })
        }
    }

    return (
        <Popup
            trigger={
                <Button className='btn btn-default'>
                    <Button sx={{color: "#ba8108"}}>
                        Change user</Button >            </Button>}
            contentStyle={{ width: '80%', overflowY: 'scroll', height: '85%' }}
            position="right"
            modal
            nested
            closeOnDocumentClick>
            {close => (
                <div class="container">
                    <div className='row align-items-center justify-content-center'>
                        <div className='col-md-10'>
                            <p className='my-2'>Select user from the folloing</p>
                        </div>

                    </div>

                    <div className='row align-items-center justify-content-center'>
                        {displayUsers()}

                    </div>
                    <div class="modal-footer">
                        <Button class="btn btn-secondary" onClick={close} >Close</Button>
                        
                    </div>
                </div>

            )}
        </Popup>

    )
}
